module.exports = __webpack_public_path__ + "media/assets/images/landing/информация-6b7c2b4e9b4231c2a03f758b44ba3128.png";